module.exports = __webpack_public_path__ + "static/media/apple.a608261a.svg";